export default __webpack_public_path__ + "static/media/develop-africa-logo.d95824c4.jpg";